import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';
import { ItemView } from './common/CommonComponents';
import { getAddressItem } from './AddressView';
import { EmploymentSetupStatus, PayrollElectionType } from '../shared/constants/employmentConstants';
import { Alert, Button } from 'antd';
import { formatAsDollars, formatAsPercent, formatName } from './common/util.js';
import { languagePreferenceItem } from './LanguagePreferenceView.js';
import { useBooleanState } from './common/commonHooks.js';

const EmployeeView = ({ employee }) => {
  const { lang, langForEnum } = useLanguage(translations);
  const fundingVisible = useBooleanState(false);

  const isActiveOrRequiresPayrollUpdate =
    employee.status === EmploymentSetupStatus.ACTIVE_EMPLOYMENT ||
    employee.status === EmploymentSetupStatus.PAYROLL_UPDATE_REQUIRED;

  const commonItems = [
    {
      field: 'name',
      value: formatName(employee.name),
    },
    {
      field: 'clientEmployeeId',
      value: employee.clientEmployeeId,
    },
  ];

  const initialItems = [
    {
      field: 'email',
      value: employee.email,
    },
    {
      field: 'phoneNumber',
      value: employee.phoneNumber,
    },
    {
      field: 'taxId',
      value: lang('taxIdNotShown'),
    },
    {
      field: 'birthday',
      value: employee.birthday,
    },
    languagePreferenceItem(employee?.languagePreference, langForEnum),
    getAddressItem(employee?.address, lang),
  ];

  const items = isActiveOrRequiresPayrollUpdate ? commonItems : [...commonItems, ...initialItems];

  const electionItems = [
    {
      field: 'electionType',
      value:
        employee.employeeRequestedPayrollElection?.electionType &&
        langForEnum(PayrollElectionType, employee.employeeRequestedPayrollElection?.electionType),
    },
    { field: 'electionPercent', value: formatAsPercent(employee.employeeRequestedPayrollElection?.electionPercent) },
    { field: 'electionDollars', value: formatAsDollars(employee.employeeRequestedPayrollElection?.electionDollars) },
  ];

  const fundingItems = [
    { field: 'routingNumber', value: fundingVisible.value ? employee.fundingDetails?.routingNumber : '#########' },
    { field: 'accountNumber', value: fundingVisible.value ? employee.fundingDetails?.accountNumber : '##########' },
  ];

  return (
    <>
      <ItemView items={items} />
      {isActiveOrRequiresPayrollUpdate && (
        <>
          <ItemView title={lang('electionDetails')} items={electionItems} />
          <ItemView title={lang('fundingDetails')} items={fundingItems} />
          <Alert description={lang('fundingDetailsInstructions')} type="warning" />
          <br />
          <Button onClick={fundingVisible.toggle}>
            {fundingVisible.value ? lang('hideFunding') : lang('showFunding')}
          </Button>
        </>
      )}
    </>
  );
};

export default EmployeeView;
